import { createRouter, createWebHistory } from 'vue-router'
import ProjectOverviewPage from '@/views/ProjectOverviewPage.vue'

import { getAuth } from 'firebase/auth'
import { getAnalytics, logEvent, setUserId } from 'firebase/analytics'

const routes = [
  { path: '/', name: 'Home', component: () => import('@/views/Home.vue') },
  { path: '/register', name: 'Register', component: () => import('@/views/Register.vue') },
  { path: '/login', name: 'Login', component: () => import('@/views/Login.vue') },

  // Protected routes
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/taskboard',
    name: 'TaskBoard',
    component: () => import('@/views/TaskBoardPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/configure-details',
    name: 'ConfigureDetails',
    component: () => import('@/views/ConfigureDetails.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/create-project',
    name: 'CreateProject',
    component: () => import('@/views/CreateProject.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/project/:id',
    name: 'ProjectOverview',
    component: ProjectOverviewPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/project/:id/details',
    name: 'ProjectDetails',
    component: () => import('@/views/ProjectDetailsPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/project/:id/timesheets',
    name: 'ProjectTimesheets',
    component: () => import('@/views/ProjectTimesheetsPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/project/:id/invoices',
    name: 'ProjectInvoices',
    component: () => import('@/views/ProjectInvoicesPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/project/:id/stats',
    name: 'ProjectStats',
    component: () => import('@/views/ProjectStatsPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/revenue',
    name: 'Revenue',
    component: () => import('@/views/RevenuePage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/checkout/:plan',
    name: 'Checkout',
    component: () => import('@/views/Checkout.vue'),
    meta: { requiresAuth: true },
  },

  // Public routes
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('@/views/PricingPage.vue'),
  },
  {
    path: '/support',               // ← New Support route
    name: 'Support',
    component: () => import('@/views/SupportPage.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

const auth = getAuth()
const analytics = getAnalytics()
router.beforeEach(async to => {
  await auth.authStateReady()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !auth.currentUser) return '/login'
  setUserId(analytics, auth.currentUser?.uid || null)
  trackPageView(to)
})

function trackPageView(to) {
  logEvent(analytics, 'page_view', {
    page_title: to.name,
    page_path: to.path,
    page_location: window.location.href,
  })
}

export default router
